// extracted by mini-css-extract-plugin
export const root = "m_r";
export const paper = "m_s";
export const form = "m_t";
export const input = "m_g";
export const inputFile = "m_v";
export const errorMsg = "m_m";
export const btnUpdate = "m_w";
export const title = "m_x";
export const profileImage = "m_y";
export const profileSection = "m_z";
export const btnUpload = "m_B";
export const passwordTitle = "m_C";